<template>
  <div class="mapa">
    <filtros-ativos-inativos
      v-show="!$wait.is('mapa')"
      :menu.sync="menu"
      :toggle-options.sync="toggleOptions"
      :dataAtivos.sync="ativosData"
      :dataInativos.sync="inativosData"
      @filtrarAtivos="getData('ativos')"
      @filtrarInativos="getData('inativos')"
      @toggle="createMapObject()"
    />
    <info-card v-show="!$wait.is('mapa')" :ativos-status="clientesAtivosStatus" :inativos-status="clientesInativosStatus" :toggle="toggleOptions" />

    <base-layer v-show="!$wait.is('mapa')" :menu="menu" :base-map-type.sync="baseMapType" @change="changeBaseMapType" />

    <map-type v-show="!$wait.is('mapa')" :menu="menu" :map-type.sync="mapType" @change="clearLayersAndCreateMap" />

    <mf-loading loader-type="dialog" :loader="['mapa', 'atualiza-mapa']" />

    <div id="map" ref="map">
      <mgl-map v-if="!$wait.is('mapa') && !!unitCoordinates" ref="mapbox" :accessToken="accessToken" :mapStyle="mapStyle" :center="getCenter" :zoom="getZoom">
        <mgl-navigation-control position="bottom-left" />

        <!-- Dots Map -->
        <mgl-geojson-layer
          v-if="mapType === 'pontos-tile'"
          :key="`${componentKey}-active-dots-layer`"
          ref="activeDotsLayer"
          :sourceId="activeDotsJsonSource.data.id"
          :source="activeDotsJsonSource"
          layerId="active-dots"
          :layer="activeDotsJsonLayer"
        />

        <mgl-geojson-layer
          v-if="mapType === 'pontos-tile'"
          :key="`${componentKey}-inactive-dots-layer`"
          ref="inactiveDotsLayer"
          :sourceId="inactiveDotsJsonSource.data.id"
          :source="inactiveDotsJsonSource"
          layerId="inactive-dots"
          :layer="inactiveDotsJsonLayer"
        />

        <!-- Heat Map -->
        <div v-if="mapType === 'calor'">
          <mgl-geojson-layer
            v-if="mapType === 'calor'"
            :key="`${componentKey}-actives-heat`"
            ref="activeHeatLayer"
            :sourceId="activesHeatJsonSource.data.id"
            :source="activesHeatJsonSource"
            layerId="actives-heat"
            :layer="activesHeatJsonLayer"
          />
          <mgl-geojson-layer
            v-if="mapType === 'calor'"
            :key="`${componentKey}-inactives-heat`"
            ref="inactiveHeatLayer"
            :sourceId="inactivesHeatJsonSource.data.id"
            :source="inactivesHeatJsonSource"
            layerId="inactives-heat"
            :layer="inactivesHeatJsonLayer"
          />
        </div>

        <!-- Cluster Map -->
        <div v-if="mapType === 'agrupamentos'">
          <mgl-geojson-layer
            v-if="mapType === 'agrupamentos'"
            :key="`${componentKey}-cluster`"
            ref="clusterLayer"
            :sourceId="clusterJsonSource.data.id"
            :source="clusterJsonSource"
            layerId="cluster"
            :layer="clusterJsonLayer"
            @click="zoomToCluster"
          />
          <mgl-geojson-layer
            v-if="mapType === 'agrupamentos'"
            :key="`${componentKey}-cluster-count`"
            ref="clusterCounterLayer"
            :sourceId="clusterJsonSource.data.id"
            :source="clusterJsonSource"
            layerId="cluster-count"
            :layer="clusterCounterJsonLayer"
          />
          <mgl-geojson-layer
            v-if="mapType === 'agrupamentos'"
            :key="`${componentKey}-active-unclustered`"
            ref="activesUnclusteredLayer"
            :sourceId="activeClusterJsonSource.data.id"
            :source="activeClusterJsonSource"
            layerId="active-unclustered"
            :layer="activesUnclusteredLayer"
          />
          <mgl-geojson-layer
            v-if="mapType === 'agrupamentos'"
            :key="`${componentKey}-inactive-unclustered`"
            ref="inactivesUnclusteredLayer"
            :sourceId="inactiveClusterJsonSource.data.id"
            :source="inactiveClusterJsonSource"
            layerId="inactive-unclustered"
            :layer="inactivesUnclusteredLayer"
          />
        </div>

        <mgl-marker v-for="store in getStoresLayers" :key="store.name" :coordinates="[store.longitude, store.latitude]" color="blue">
          <mgl-popup>
            <div>{{ store.name }}</div>
          </mgl-popup>
          <img slot="marker" :src="require('@/assets/store_pin.png')" height="50" />
        </mgl-marker>
      </mgl-map>
    </div>

    <filters-menu
      v-show="!$wait.is('mapa')"
      :menu.sync="menu"
      :filter-cliente.sync="clienteFilter"
      :filter-pessoa.sync="pessoaFilter"
      :filter-lojas.sync="unidadesFilter"
      :filter-units-configuration.sync="unitsConfigurationFilter"
      :filter-clube.sync="clubeFilter"
      @filtrar="filtrar"
    />
  </div>
</template>

<script>
import FiltersMenu from '@/modules/clientes/mapa/views/pages/FiltersMenu.vue'
import FiltrosAtivosInativos from '@/modules/clientes/mapa/views/pages/FiltrosAtivosInativos.vue'
import InfoCard from '@/modules/clientes/mapa/views/pages/InfoCard.vue'
import BaseLayer from '@/modules/clientes/mapa/views/pages/BaseLayer.vue'
import MapType from '@/modules/clientes/mapa/views/pages/MapType.vue'
import Mapbox from 'mapbox-gl'

import { mapState, mapGetters } from 'vuex'
import { mapWaitingActions } from 'vue-wait'
import { DateTime } from 'luxon'
import { MglMap, MglGeojsonLayer, MglMarker, MglPopup, MglNavigationControl } from 'vue-mapbox'

const BATCH_SIZE = 2000
const EXCESS_DATA_SIZE = 250000

export default {
  components: {
    FiltersMenu,
    FiltrosAtivosInativos,
    InfoCard,
    BaseLayer,
    MapType,

    MglMap,
    MglGeojsonLayer,
    MglMarker,
    MglPopup,
    MglNavigationControl,
  },
  data: () => ({
    closeStream: false,
    customersInactiveCoordinates: [],
    customersActiveCoordinates: [],
    componentKey: 0,
    loading: true,
    toggleOptions: ['ativos', 'inativos'],
    baseMapType: 'normal',
    mapType: 'pontos-tile',
    menu: false,
    ativosData: null,
    inativosData: null,
    clienteFilter: [],
    pessoaFilter: ['F', 'J'],
    unidadesFilter: [],
    unitsConfigurationFilter: [],
    clubeFilter: ['1', '0'],

    accessToken: 'pk.eyJ1IjoibWVyY2FmYWNpbCIsImEiOiJjbDM3bWpndnIwdDZuM2NsZHVvNmhteHAxIn0.ISPOboOmgzPnFJNO_CQnsQ', // your access token. Needed if you using Mapbox maps
    inactiveDotsJsonSource: {
      type: 'geojson',
      data: {
        id: 'inactive-dots',
        type: 'FeatureCollection',
        features: [],
      },
    },
    inactiveDotsJsonLayer: {
      id: 'inactive-dots',
      type: 'circle',
      source: 'inactive-dots',
      paint: {
        'circle-color': 'rgba(224, 50, 17, 0.4)',
        'circle-radius': 4,
        'circle-stroke-width': 1,
        'circle-stroke-color': 'rgba(224, 50, 17, 1)',
      },
    },
    activeDotsJsonSource: {
      type: 'geojson',
      data: {
        id: 'active-dots',
        type: 'FeatureCollection',
        features: [],
      },
    },
    activeDotsJsonLayer: {
      id: 'active-dots',
      type: 'circle',
      source: 'active-dots',
      paint: {
        'circle-color': 'rgba(13, 167, 64, 0.4)',
        'circle-radius': 4,
        'circle-stroke-width': 1,
        'circle-stroke-color': 'rgba(13, 167, 64, 1)',
      },
    },
    // End Dots

    // Start Heatmap
    activesHeatJsonLayer: {
      id: 'actives-heat',
      type: 'heatmap',
      source: 'actives-heat',
      maxZoom: 100,
      paint: {
        'heatmap-weight': 1,
        'heatmap-color': [
          'interpolate',
          ['linear'],
          ['heatmap-density'],
          0,
          'rgba(33,102,172,0)',
          0.2,
          'rgba(13, 167, 64, 0.2)',
          0.4,
          'rgba(13, 167, 64, 0.4)',
          0.6,
          'rgba(13, 167, 64, 0.6)',
          0.8,
          'rgba(13, 167, 64, 8)',
          1,
          'rgba(13, 167, 64, 1)',
        ],
        'heatmap-radius': 30,
        'heatmap-opacity': ['interpolate', ['linear'], ['zoom'], 7, 1, 9, 0.8],
      },
    },
    inactivesHeatJsonLayer: {
      id: 'inactives-heat',
      type: 'heatmap',
      source: 'inactives-heat',
      maxZoom: 100,
      paint: {
        'heatmap-weight': 1,
        'heatmap-color': [
          'interpolate',
          ['linear'],
          ['heatmap-density'],
          0,
          'rgba(33,102,172,0)',
          0.2,
          'rgba(224, 50, 17, 0.2)',
          0.4,
          'rgba(224, 50, 17, 0.4)',
          0.6,
          'rgba(224, 50, 17, 0.6)',
          0.8,
          'rgba(224, 50, 17, 8)',
          1,
          'rgba(224, 50, 17, 1)',
        ],
        'heatmap-radius': 30,
        'heatmap-opacity': ['interpolate', ['linear'], ['zoom'], 7, 1, 9, 0.8],
      },
    },
    inactivesHeatJsonSource: {
      type: 'geojson',
      data: {
        id: 'inactives-heat',
        type: 'FeatureCollection',
        features: [],
      },
    },
    activesHeatJsonSource: {
      type: 'geojson',
      data: {
        id: 'actives-heat',
        type: 'FeatureCollection',
        features: [],
      },
    },
    // End Heatmap

    // Start Cluster
    clusterJsonLayer: {
      id: 'cluster',
      type: 'circle',
      source: 'cluster',
      filter: ['has', 'point_count'],
      paint: {
        'circle-color': ['step', ['get', 'point_count'], 'rgba(252, 190, 0, 0.28)', 100, 'rgba(252, 190, 0, 0.28)', 750, 'rgba(252, 190, 0, 0.28)'],
        'circle-radius': ['step', ['get', 'point_count'], 20, 100, 30, 750, 40],
      },
    },
    clusterCounterJsonLayer: {
      id: 'cluster-count',
      type: 'symbol',
      source: 'cluster',
      filter: ['has', 'point_count'],
      layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
        'text-size': 12,
      },
    },
    activesUnclusteredLayer: {
      id: 'active-unclustered',
      type: 'circle',
      source: 'active-cluster',
      filter: ['!', ['has', 'point_count']],
      paint: {
        'circle-color': 'rgba(13, 167, 64, 0.4)',
        'circle-radius': 4,
        'circle-stroke-width': 1,
        'circle-stroke-color': 'rgba(13, 167, 64, 1)',
      },
    },
    inactivesUnclusteredLayer: {
      id: 'inactive-unclustered',
      type: 'circle',
      source: 'inactive-cluster',
      filter: ['!', ['has', 'point_count']],
      paint: {
        'circle-color': 'rgba(224, 50, 17, 0.4)',
        'circle-radius': 4,
        'circle-stroke-width': 1,
        'circle-stroke-color': 'rgba(224, 50, 17, 1)',
      },
    },
    clusterJsonSource: {
      type: 'geojson',
      cluster: true,
      clusterMaxZoom: 14,
      clusterRadius: 50,
      data: {
        id: 'cluster',
        type: 'FeatureCollection',
        features: [],
      },
    },
    activeClusterJsonSource: {
      type: 'geojson',
      cluster: true,
      clusterMaxZoom: 14,
      clusterRadius: 50,
      data: {
        id: 'active-cluster',
        type: 'FeatureCollection',
        features: [],
      },
    },
    inactiveClusterJsonSource: {
      type: 'geojson',
      cluster: true,
      clusterMaxZoom: 14,
      clusterRadius: 50,
      data: {
        id: 'inactive-cluster',
        type: 'FeatureCollection',
        features: [],
      },
    },
    // End Cluster
  }),
  computed: {
    ...mapState({
      unitCoordinates: (state) => state.geo.unitCoordinates,
      clientesAtivosCoordinates: (state) => state.geo.clientesAtivosCoordinates,
      clientesInativosCoordinates: (state) => state.geo.clientesInativosCoordinates,
      clientesAtivosStatus: (state) => state.geo.clientesAtivosStatus,
      clientesInativosStatus: (state) => state.geo.clientesInativosStatus,
      lastUpdate: (state) => state.lastUpdate,
    }),
    ...mapGetters(['units']),
    mapStyle() {
      return this.baseMapType === 'normal' ? 'mapbox://styles/mercafacil/clar1vqke001e14o1pjqgqfu1' : 'mapbox://styles/mapbox/satellite-streets-v11'
    },
    getStoresLayers() {
      if (!this.unitCoordinates) return []
      let stores = []
      const filteredUnits = this.unitCoordinates.filter((unit) => this.unidadesFilter.includes(unit.COD_ID_LOJA))
      for (let unit of filteredUnits) {
        stores.push({
          latitude: unit['NUM_LAT'],
          longitude: unit['NUM_LNG'],
          name: 'Loja ' + unit['COD_ID_LOJA'],
        })
      }
      return stores
    },
    getZoom() {
      if (this.unitCoordinates.length > 1) return 8
      return 15
    },
    getCenter() {
      const unit = this.unitCoordinates[0]
      return [unit['NUM_LNG'], unit['NUM_LAT']]
    },
    getActiveFeatures() {
      const hasActive = this.toggleOptions.includes('ativos')
      return hasActive
        ? this.clientesAtivosCoordinates.map((client, index) => {
            return {
              type: 'Feature',
              properties: {
                id: index,
                color: 'rgba(13, 167, 64, 1)',
              },
              geometry: {
                type: 'Point',
                coordinates: [client[2], client[1]],
              },
            }
          })
        : []
    },
    getInactiveFeatures() {
      const hasInactive = this.toggleOptions.includes('inativos')
      return hasInactive
        ? this.clientesInativosCoordinates.map((client, index) => {
            return {
              type: 'Feature',
              properties: {
                id: index,
                color: 'rgba(224, 50, 17, 1)',
              },
              geometry: {
                type: 'Point',
                coordinates: [client[2], client[1]],
              },
            }
          })
        : []
    },
    filterAtivos() {
      return {
        date: [DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd').toFormat('yyyy-MM')],
        tipo_pessoa: this.pessoaFilter,
        categoria_cliente: this.clienteFilter,
        kpi: 'clientes_ativos',
        unidades: this.unidadesFilter,
        fidelidade: this.clubeFilter,
      }
    },
    filterInativos() {
      return {
        date: [DateTime.fromFormat(this.lastUpdate.last_updated.toString(), 'yyyyMMdd').toFormat('yyyy-MM')],
        tipo_pessoa: this.pessoaFilter,
        categoria_cliente: this.clienteFilter,
        kpi: 'clientes_perdidos',
        unidades: this.unidadesFilter,
        fidelidade: this.clubeFilter,
      }
    },
  },
  async mounted() {
    this.$wait.start('mapa')
    this.$store.dispatch('getStates', ['getLastUpdate']).then(() => {
      this.unidadesFilter = this.units.map((unit) => unit.id_erp)
      Promise.all([
        this.getUnitCoordinates({ unidades: this.unidadesFilter }),
        this.getClientesAtivosCoordinates(this.filterAtivos),
        this.getClientesInativosCoordinates(this.filterInativos),
      ]).then(() => {
        this.updateClientStatus()
        this.createMapObject()
        if (this.isExcessDataSize()) {
          try {
            this.consumeTransformedInactiveCoordinates(this.generateCoordinatesGradually(this.clientesInativosCoordinates), this.transformInactiveCoordinates)
            this.consumeTransformedActiveCoordinates(this.generateCoordinatesGradually(this.clientesAtivosCoordinates), this.transformActiveCoordinates)
          } catch (error) {
            console.log(error.message)
          }
        }
        this.$wait.end('mapa')
      })
    })

    // removing overflow from page with JS (::v-deep didn't worked with scoped css)
    const wrapper = document.querySelector('.v-content__wrap')
    wrapper.style.overflow = 'hidden'

    this.mapbox = Mapbox
  },
  destroyed() {
    const wrapper = document.querySelector('.v-content__wrap')
    wrapper.removeAttribute('style')
  },
  methods: {
    ...mapWaitingActions({
      getUnitCoordinates: 'unit-coordinates',
      getClientesAtivosCoordinates: 'ativos-coordinates',
      getClientesInativosCoordinates: 'inativos-coordinates',
      getClientesAtivosGeoStatus: 'ativos-geo-status',
      getClientesInativosGeoStatus: 'inativos-geo-status',
    }),
    isExcessDataSize() {
      return this.clientesInativosCoordinates.length + this.clientesAtivosCoordinates.length > EXCESS_DATA_SIZE
    },
    createMapObject() {
      this.createClientsDots(this.isExcessDataSize())
      this.createClientsHeatmap(this.isExcessDataSize())
      this.createClientsCluster(this.isExcessDataSize())
    },
    clearLayersAndCreateMap() {
      this.clearDots()
      this.clearHeats()
      this.clearClusters()
      this.createMapObject()
    },
    clearDots() {
      if (this.$refs.mapbox.map.getLayer('active-dots')) {
        this.$refs.mapbox.map.removeLayer('active-dots')
        this.$refs.mapbox.map.removeSource('active-dots')
        this.activeDotsJsonSource = null
      }
      if (this.$refs.mapbox.map.getLayer('inactive-dots')) {
        this.$refs.mapbox.map.removeLayer('inactive-dots')
        this.$refs.mapbox.map.removeSource('inactive-dots')
        this.inactiveDotsJsonSource = null
      }
    },
    clearHeats() {
      if (this.$refs.mapbox.map.getLayer('inactives-heat')) {
        this.$refs.mapbox.map.removeLayer('inactives-heat')
        this.$refs.mapbox.map.removeSource('inactives-heat')
        this.activesHeatJsonSource = null
      }

      if (this.$refs.mapbox.map.getLayer('actives-heat')) {
        this.$refs.mapbox.map.removeLayer('actives-heat')
        this.$refs.mapbox.map.removeSource('actives-heat')
        this.activesHeatJsonSource = null
      }
    },
    clearClusters() {
      if (this.$refs.mapbox.map.getLayer('active-unclustered')) {
        this.$refs.mapbox.map.removeLayer('active-unclustered')
        this.$refs.mapbox.map.removeSource('active-cluster')
        this.activeClusterJsonSource = null
      }

      if (this.$refs.mapbox.map.getLayer('inactive-unclustered')) {
        this.$refs.mapbox.map.removeLayer('inactive-unclustered')
        this.$refs.mapbox.map.removeSource('inactive-cluster')
        this.inactiveClusterJsonSource = null
      }

      if (this.$refs.mapbox.map.getLayer('cluster')) {
        this.$refs.mapbox.map.removeLayer('cluster')
        this.$refs.mapbox.map.removeLayer('cluster-count')
        this.$refs.mapbox.map.removeSource('cluster')
        this.clusterJsonSource = null
      }
    },
    createClientsDots(isExcessDataSize) {
      let activeFeatures
      let inactiveFeatures
      if (isExcessDataSize) {
        activeFeatures = this.mapType !== 'pontos-tile' ? [] : [...this.customersActiveCoordinates]
        inactiveFeatures = this.mapType !== 'pontos-tile' ? [] : [...this.customersInactiveCoordinates]
      } else {
        activeFeatures = this.mapType !== 'pontos-tile' ? [] : [...this.getActiveFeatures]
        inactiveFeatures = this.mapType !== 'pontos-tile' ? [] : [...this.getInactiveFeatures]
      }

      this.activeDotsJsonSource = {
        type: 'geojson',
        data: {
          id: 'active-dots',
          type: 'FeatureCollection',
          features: activeFeatures,
        },
      }

      this.inactiveDotsJsonSource = {
        type: 'geojson',
        data: {
          id: 'inactive-dots',
          type: 'FeatureCollection',
          features: inactiveFeatures,
        },
      }
    },
    checkMemory() {
      const totalMemory = window.performance.memory.jsHeapSizeLimit
      const usedMemory = window.performance.memory.usedJSHeapSize
      const safetyMargin = 0.2
      const memoryLimit = totalMemory - totalMemory * safetyMargin

      if (usedMemory > memoryLimit) {
        console.log('Memory usage exceeded the limit. Pausing the stream...')
        this.closeStream = true
      }
    },
    generateCoordinatesGradually(coordinates) {
      let index = 0
      const that = this

      return new ReadableStream({
        start(controller) {
          function pushCoordinates() {
            if (that.closeStream) controller.close()
            if (index < coordinates.length) {
              const chunk = coordinates.slice(index, index + BATCH_SIZE)
              index += 10000
              controller.enqueue(chunk)
              setTimeout(pushCoordinates, 1)
            } else {
              controller.close()
            }
          }

          pushCoordinates()
        },
      })
    },
    consumeTransformedInactiveCoordinates(readableStream, transform) {
      const that = this
      const writableStream = new WritableStream({
        write(chunk) {
          that.checkMemory()
          that.customersInactiveCoordinates.push(...chunk)
          that.createMapObject()
        },
        close() {
          console.log('Stream closed')
        },
      })

      this.startStream(readableStream, transform, writableStream)
    },
    consumeTransformedActiveCoordinates(readableStream, transform) {
      const that = this
      const writableStream = new WritableStream({
        write(chunk) {
          that.checkMemory()
          that.customersActiveCoordinates.push(...chunk)
          that.createMapObject()
        },
        close() {
          console.log('Stream closed')
        },
      })

      this.startStream(readableStream, transform, writableStream)
    },
    transformInactiveCoordinates(coordinates) {
      return coordinates.map((client, index) => {
        return {
          type: 'Feature',
          properties: {
            id: `inactive-${index}`,
            color: 'rgba(224, 50, 17, 1)',
          },
          geometry: {
            type: 'Point',
            coordinates: [client[2], client[1]],
          },
        }
      })
    },
    transformActiveCoordinates(coordinates) {
      return coordinates.map((client, index) => {
        return {
          type: 'Feature',
          properties: {
            id: `active-${index}`,
            color: 'rgba(13, 167, 64, 1)',
          },
          geometry: {
            type: 'Point',
            coordinates: [client[2], client[1]],
          },
        }
      })
    },
    startStream(readableStream, transform, writableStream) {
      readableStream
        .pipeThrough(
          new TransformStream({
            transform(chunk, controller) {
              controller.enqueue(transform(chunk))
            },
          })
        )
        .pipeTo(writableStream)
    },
    createClientsHeatmap(isExcessDataSize) {
      let activeFeatures
      let inactiveFeatures
      if (isExcessDataSize) {
        activeFeatures = this.mapType !== 'calor' ? [] : [...this.customersActiveCoordinates]
        inactiveFeatures = this.mapType !== 'calor' ? [] : [...this.customersInactiveCoordinates]
      } else {
        activeFeatures = this.mapType !== 'calor' ? [] : [...this.getActiveFeatures]
        inactiveFeatures = this.mapType !== 'calor' ? [] : [...this.getInactiveFeatures]
      }

      this.inactivesHeatJsonSource = {
        type: 'geojson',
        data: {
          id: 'inactives-heat',
          type: 'FeatureCollection',
          features: inactiveFeatures,
        },
      }
      this.activesHeatJsonSource = {
        type: 'geojson',
        data: {
          id: 'actives-heat',
          type: 'FeatureCollection',
          features: activeFeatures,
        },
      }
    },
    createClientsCluster(isExcessDataSize) {
      let features
      let activeFeatures
      let inactiveFeatures

      if (isExcessDataSize) {
        features = this.mapType !== 'agrupamentos' ? [] : [...this.customersActiveCoordinates, ...this.customersInactiveCoordinates]
        activeFeatures = this.mapType !== 'agrupamentos' ? [] : [...this.customersActiveCoordinates]
        inactiveFeatures = this.mapType !== 'agrupamentos' ? [] : [...this.customersInactiveCoordinates]
      } else {
        features = this.mapType !== 'agrupamentos' ? [] : [...this.getActiveFeatures, ...this.getInactiveFeatures]
        activeFeatures = this.mapType !== 'agrupamentos' ? [] : [...this.getActiveFeatures]
        inactiveFeatures = this.mapType !== 'agrupamentos' ? [] : [...this.getInactiveFeatures]
      }

      this.clusterJsonSource = {
        type: 'geojson',
        cluster: true,
        clusterMaxZoom: 14,
        clusterRadius: 50,
        data: {
          id: 'cluster',
          type: 'FeatureCollection',
          features,
        },
      }
      this.activeClusterJsonSource = {
        type: 'geojson',
        cluster: true,
        clusterMaxZoom: 14,
        clusterRadius: 50,
        data: {
          id: 'active-cluster',
          type: 'FeatureCollection',
          features: activeFeatures,
        },
      }
      this.inactiveClusterJsonSource = {
        type: 'geojson',
        cluster: true,
        clusterMaxZoom: 14,
        clusterRadius: 50,
        data: {
          id: 'inactive-cluster',
          type: 'FeatureCollection',
          features: inactiveFeatures,
        },
      }
    },
    zoomToCluster(cluster) {
      const point = cluster.mapboxEvent.point
      const features = this.$refs.mapbox.map.queryRenderedFeatures(point, { layers: ['cluster'] })
      const clusterId = features[0].properties.cluster_id

      this.$refs.mapbox.map.getSource('cluster').getClusterExpansionZoom(clusterId, (err, zoom) => {
        if (err) return
        this.$refs.mapbox.map.easeTo({
          center: features[0].geometry.coordinates,
          zoom: zoom,
        })
      })
    },
    changeBaseMapType() {
      setTimeout(() => {
        this.componentKey += 1
      }, 300)
    },
    filtrar() {
      this.$wait.start('atualiza-mapa')
      Promise.all([this.getClientesAtivosCoordinates(this.filterAtivos), this.getClientesInativosCoordinates(this.filterInativos)]).then(() => {
        this.updateClientStatus()
        this.createMapObject()
        this.$wait.end('atualiza-mapa')
      })
    },
    getData(selection) {
      if (selection === 'ativos') {
        this.getClientesAtivosCoordinates(this.filterAtivos).then(() => {
          this.updateClientStatus()
        })
      } else if (selection === 'inativos') {
        this.getClientesInativosCoordinates(this.filterInativos).then(() => {
          this.updateClientStatus()
        })
      }
    },
    updateClientStatus() {
      this.getClientesAtivosGeoStatus(this.filterAtivos)
      this.getClientesInativosGeoStatus(this.filterInativos)
    },
  },
}
</script>
<style lang="scss" scoped>
.mapa {
  overflow: hidden;
  position: unset;
  #map {
    overflow: hidden;
    height: calc(100vh - 64px);
    z-index: 2;
  }
  // close tooltip button
  .mapboxgl-popup-close-button {
    width: 18px;
    height: 14px;
    font: 16px/14px Tahoma, Verdana, sans-serif;
    color: $cinza-l70;
    text-decoration: none;
    font-weight: bold;
    background: transparent;
    padding: 3px 3px 0 0;
  }
  .mapboxgl-popup-content {
    padding: 15px;
    border-radius: 10px;
  }
  .opened-menu-bottom {
    margin-right: 370px !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .v-btn-toggle .v-btn {
    padding: 0 15px;
  }
  .map-type {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 3;
    margin-right: 20px;
    margin-bottom: 20px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .select-base-layer {
    position: absolute;
    right: 0;
    bottom: 45px;
    z-index: 3;
    margin-right: 20px;
    margin-bottom: 20px;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .side-menu {
    z-index: 12 !important;
    height: auto;
  }
  .opened-menu-top {
    margin-right: 350px !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  }
}
</style>
